<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {Link, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Link, Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      tagId: '',

      form: useForm({
        name: '',
      })
    }
  },
  methods: {
    setTag(tag) {
      this.tagId = tag.id;

      this.form.defaults({
        name: tag.name
      });
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <div class="row g-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Details</h2>

        <Input
            :form="form"
            v-model="form.name"
            name="name"
            :required="true"
            label="Label"
        />
      </Card>
    </div>
  </div>

</template>